import React from 'react';
import { connect } from 'react-redux';
import { Button, Form, Input } from 'antd';

import Content from '../../layout/Content/Content';
import Title from '../../components/Title/Title';
import CustomButton from '../../components/Button/Button';
import { resetEmailSentStatus, userRequestActionRestore } from '../../reducers/initReducer';
import './ForgotPassword.scss';
import acbaLogo from "../../assets/img/acba-30.png";

class ForgotPassword extends React.Component {
  onSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.dispatch(userRequestActionRestore(values.userName));
      }
    });
  };

  componentWillUnmount() {
    this.props.dispatch(resetEmailSentStatus());
  }

  render() {
    const { isEmailSent } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className='medium-large-flex-container row-wrap fluid-y' >
        <Content>
          <div className='row align-center fluid-y align-middle'>
            <div className='column small-12 medium-large-6 forgot-pass-max' >
              {
                isEmailSent
                  ? (
                    <Title
                      size='xs'
                      weight='medium'
                      className='mb_35 color-green capitalize-first-letter'
                      text='Գաղտնաբառի փոփոխությունը կատարելու համար հարկավոր է անցնել էլ.հասցեին ուղարկված հղմամբ'
                    />
                  ) : (
                    <>
                        <div className='text-center'>
                            <img src={acbaLogo} style={{width: 300}} alt="logo" />
                        </div>
                      <Title text='Մոռացել եմ գաղտնաբառը' size='md' weight='black' className='mb_35 capitalize-first-letter text-center' />
                      <Form onSubmit={this.onSubmit} >
                        <Form.Item label='Մուտքանուն' >
                          {getFieldDecorator('userName', {
                            rules: [{required: true, message: 'դաշտը լրացված չէ'}],
                          })(
                            <Input type='text' />
                          )}
                        </Form.Item>
  
                        <div className='actions-container flex-container align-justify row-wrap gap-10' >
                          <Button
                            loading={this.props.loading}
                            htmlType="submit"
                            className="btn btn-green"
                            id={'change_password'}
                          >
                            <span>Փոխել գաղտնաբառը</span>
                          </Button>
  
                          <CustomButton
                            text='ՉԵՂԱՐԿԵԼ'
                            linkTo='/singin'
                            className="btn btn-green"
                            id={'cancel_change_password'}
                          />
                        </div>
                      </Form>
                    </>
                  )
              }
            </div>
          </div>
        </Content>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.initReducer.loading,
    isEmailSent: state.initReducer.isEmailSent,
    error_message: state.initReducer.error_message,
  };
}

const ForgotPasswordContainer = Form.create()(ForgotPassword);

export default connect(mapStateToProps)(ForgotPasswordContainer);
